export enum MapContentViews {
  main = 'mapContent_tool_main',
  addTopic = 'mapContent_tool_add_topic',
  topicSettings = 'mapContent_tool_topic_settings',
  topicAttributeSearch = 'mapContent_tool_topic_attribute_search',
}
